// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '2.0.0';
export const API_BASE_URL = '/api';
export const ENABLE_REDUX_LOGGER = false;

export const CertContractAddress = "0xe277397ca4cd8fd99c24bb0baf6b3cf9d267bc61"

export default {};
